import PropTypes from 'prop-types';

const StickyHeader = ({ children, offset, offsetAmountClass, ...rest }) => {
  return (
    <div
      {...rest}
      className={`sticky flex justify-between py-4 mb-6 bg-white border-b border-solid border-b-gray-2 ${
        offset ? offsetAmountClass : 'top-0'
      }`}
    >
      {children}
    </div>
  );
};

StickyHeader.defaultProps = {
  offset: false,
  offsetAmountClass: 'top-12',
};

StickyHeader.propTypes = {
  children: PropTypes.node.isRequired,
  offset: PropTypes.bool,
  offsetAmountClass: PropTypes.string,
};

export default StickyHeader;
